import { render, staticRenderFns } from "./Optimizer.vue?vue&type=template&id=047d7488&"
import script from "./Optimizer.vue?vue&type=script&lang=js&"
export * from "./Optimizer.vue?vue&type=script&lang=js&"
import style0 from "./Optimizer.vue?vue&type=style&index=0&id=047d7488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports